export default __webpack_public_path__ + "static/media/MEDsmall.f8cb286f.png";